import { App } from 'vue';

import type { LocalModule } from './types';

/**
 * Modular
 *
 * Load index.ts from each /src/Module/ directory
 * and run setup() function.
 */
class Modular {
    constructor(app: App<Element>) {
        const setups = this.setups();

        setups.forEach((localModule) => localModule.setup(app));
    }

    public setups() {
        return Object.values(this.get()).filter((entry) => entry.setup && typeof entry.setup === 'function');
    }

    /**
     * Get list of module index file setup() functions
     *
     * @returns Record<string, LocalModule>
     */
    public get(): Record<string, LocalModule> {
        return import.meta.glob('/src/*/index.ts', { eager: true }) as Record<string, LocalModule>;
    }

    /**
     * TODO: it's now possible to distinguish between enabled/available/core modules and load them accordingly
     */
    public available() {
        // import availableString from '/config/modules-available.php?raw';
    }
}

export { Modular };
